var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppDataPlaceholderTexture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 342,
    viewBox: "0 0 380 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M360.007 66.7394C358.759 64.6252 357.442 62.5373 356.057 60.4759C337.792 33.2415 306.238 14.6492 275.237 6.19739C261.636 2.56573 247.663 0.519886 233.595 0.10037C141.461 -3.07103 104.772 69.8316 74.3164 88.638C43.8607 107.444 -2.97233 139.571 0.148297 206.955C3.26892 274.339 51.682 337.775 145.372 341.74C239.062 345.704 245.303 303.342 297.619 287.675C332.23 277.305 356.871 242.276 368.872 209.904C385.288 165.774 384.514 108.467 360.007 66.7394Z",
    fill: "#BAE2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppDataPlaceholderTexture);
export default __webpack_public_path__ + "static/media/appDataPlaceholderTexture.ef72a8faced5775f27deeacb2d1342a0.svg";
export { ForwardRef as ReactComponent };